import axios from "axios";

const ApiReport = axios.create({
  baseURL: process.env.REACT_APP_APP_API_REPORT_URL,
  timeout: 0
});

export default ApiReport;
